<template>
  <div class="car-type">
    <!-- 查找参数区 -->
    <div class="filter-container">
      <el-input placeholder="请输入机器人型号名称" v-model="listQuery.params.name" style="width: 200px" class="filter-item"
        @input="e => listQuery.params.name = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
        @click="handleFilter">
        搜索
      </el-button>
     <el-button class="filter-item" style="margin-left: 10px;" icon="el-icon-edit" type="success"
        @click="handleCreate">
        新建
      </el-button>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;">
      <!-- @selection-change="handleSelectionChange"> -->
      <el-table-column prop="name" label="机器人型号名称" width="150" align="center"></el-table-column>
      <el-table-column prop="typeName" label="所属类别" width="150" align="center"></el-table-column>
      <el-table-column prop="functions" label="可执行功能" width="600" align="center"></el-table-column>
      <el-table-column prop="size" label="长 × 宽 × 高" align="center">
      </el-table-column>
      <el-table-column prop="weight" label="重量（千克）" align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作" width="150" align="center">
        <template v-slot:="{row,$index}">
          <el-select value="操作类型">
            <el-option v-for="(item, index) in tableOptions" :key="item" :value="index"
              @click.native="handleOperator(index, row)">
              {{item}}
            </el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination :total="totalCounts" @pagination="handlePageChange">
    </pagination>

    <!-- 新建（编辑）车辆类型 -->
    <el-dialog  :visible.sync="carTypeDialogVisable" :title="dialogTitleType ==='edit'?'编辑机器人类型':'新建机器人类型'"
      width="500px"  >
      <el-form :model="formCarTypeData" label-position="right" label-width="100px">
       <!-- <el-form-item label="所属单位" prop="entityId">
          <el-select v-model="formCarTypeData.addtypeEntityId" placeholder="请选择所属单位" style="width:100%"
            :disabled="enbleSelect">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
		
<!--        <el-form-item label="类型名称:" prop="addtypeName">
          <el-input v-model="formCarTypeData.addtypeName" placeholder="请输入类型名称" maxlength="20"
            @input="e => formCarTypeData.addtypeName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
        </el-form-item>

        <el-form-item label="型号名称:" prop="addtypeModel">
          <el-input v-model="formCarTypeData.addtypeModel" placeholder="请输入型号名称" maxlength="20"></el-input>
        </el-form-item> -->
		
		<el-form-item label="机器人型号" prop="addmodelName">
		  <el-input v-model="formCarTypeData.addmodelName" placeholder="请输入机器人型号名称" maxlength="20" />
		</el-form-item>
		
		<el-form-item label="所属类别" prop="addtypeId">
		  <el-select v-model="formCarTypeData.addtypeId" placeholder="请选择机器人类别">
		        <el-option v-for="cartypeinfo in carTypeOptions" :label="cartypeinfo.name" :value="cartypeinfo.id" :key="cartypeinfo.id"></el-option>
		  </el-select>
		</el-form-item>

        <el-row>
          <el-col :span="12">   <!--  @input="e => formCarTypeData.addtypeLength = e.replace(/[^\d.]/g,'')"  
		   @keyup.native="keyUpValidate(1,formCarTypeData.addtypeLength)"-->
            <el-form-item label="长(米):" prop="addtypeLength">
              <el-input v-model="formCarTypeData.addtypeLength" placeholder="请输入长度" maxlength="7">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">   <!--  @input="e => formCarTypeData.addtypeWidth = e.replace(/[^\d.]/g,'')"
		   @keyup.native="keyUpValidate(2,formCarTypeData.addtypeWidth)"-->
            <el-form-item label="宽(米):" prop="addtypeWidth">
              <el-input v-model="formCarTypeData.addtypeWidth" placeholder="请输入宽度" maxlength="7" >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12"> <!--  @input="e => formCarTypeData.addtypeHeight = e.replace(/[^\d.]/g,'')"
		   @keyup.native="keyUpValidate(3,formCarTypeData.addtypeHeight)"-->
            <el-form-item label="高(米):" prop="addtypeHeight">
              <el-input v-model="formCarTypeData.addtypeHeight" placeholder="请输入高度" maxlength="7" >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"> <!--  @input="e => formCarTypeData.addtypeWeight = e.replace(/[^\d.]/g,'')"
		   @keyup.native="keyUpValidate(4,formCarTypeData.addtypeWeight)"-->
            <el-form-item label="重量(千克):" prop="addtypeWeight">
              <el-input v-model="formCarTypeData.addtypeWeight" placeholder="请输入重量" maxlength="7" >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

       <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="最高时速:" prop="addtypeTopSpeed">
              <el-input v-model="formCarTypeData.addtypeTopSpeed" placeholder="请输入最高时速" maxlength="7"
              @input="e => formCarTypeData.addtypeTopSpeed = e.replace(/[^\d.]/g,'')"
                @keyup.native="keyUpValidate(14,formCarTypeData.addtypeTopSpeed)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="续航时间:" prop="addtypeEnduranceTime">
              <el-input v-model="formCarTypeData.addtypeEnduranceTime" placeholder="请输入续航时间" maxlength="7"
              @input="e => formCarTypeData.addtypeEnduranceTime = e.replace(/[^\d.]/g,'')"
                @keyup.native="keyUpValidate(15,formCarTypeData.addtypeEnduranceTime)">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

       <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="电池电压:" prop="addtypeBatteryVoltage">
              <el-input v-model="formCarTypeData.addtypeBatteryVoltage" placeholder="请输入电池电压" maxlength="7"
              @input="e => formCarTypeData.addtypeBatteryVoltage = e.replace(/[^\d.]/g,'')"
                @keyup.native="keyUpValidate(16,formCarTypeData.addtypeBatteryVoltage)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电池容量:" prop="addtypeBatteryCapacity">
              <el-input v-model="formCarTypeData.addtypeBatteryCapacity" placeholder="请输入电池容量" maxlength="7"
              @input="e => formCarTypeData.addtypeBatteryCapacity = e.replace(/[^\d.]/g,'')"
                @keyup.native="keyUpValidate(17,formCarTypeData.addtypeBatteryCapacity)">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carTypeDialogVisable = false">返 回</el-button>
        <el-button type="primary" @click="createCarType()">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 配置费用弹出框 -->
    <el-dialog title="配置费用" :visible.sync="feeDialogVisable" width="800px"  >
      <el-form :model="formCarTypeData" label-position="right" label-width="150px">
        <el-form-item label="机器人成本费用标准:" prop="addtypeCarCost">
          <el-input v-model="formCarTypeData.addtypeCarCost" placeholder="请输入机器人成本"
            @input="e => formCarTypeData.addtypeCarCost = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(5,formCarTypeData.addtypeCarCost)"></el-input>
        </el-form-item>
        <el-form-item label="保险费用标准:" prop="addtypeInsurance">
          <el-input v-model="formCarTypeData.addtypeInsurance" placeholder="请输入保险费用"
          @input="e => formCarTypeData.addtypeInsurance = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(6,formCarTypeData.addtypeInsurance)">
          </el-input>
        </el-form-item>
        <el-form-item label="维修保养费用标准:" prop="addtypeMaintenanceFees">
          <el-input v-model="formCarTypeData.addtypeMaintenanceFees" placeholder="请输入维修保养费用"
          @input="e => formCarTypeData.addtypeMaintenanceFees = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(7,formCarTypeData.addtypeMaintenanceFees)">
          </el-input>
        </el-form-item>
        <el-form-item label="充电费用标准:" prop="addtypeChargingFee">
          <el-input v-model="formCarTypeData.addtypeChargingFee" placeholder="请输入充电费用"
          @input="e => formCarTypeData.addtypeChargingFee = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(8,formCarTypeData.addtypeChargingFee)">
          </el-input>
        </el-form-item>
        <el-form-item label="发票税费标准:" prop="addtypeInvoiceTax">
          <el-input v-model="formCarTypeData.addtypeInvoiceTax" placeholder="请输入发票税费"
          @input="e => formCarTypeData.addtypeInvoiceTax = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(9,formCarTypeData.addtypeInvoiceTax)">
          </el-input>
        </el-form-item>
        <el-form-item label="押金费用标准:" prop="addtypeDeposit">
          <el-input v-model="formCarTypeData.addtypeDeposit" placeholder="请输入押金费用"
          @input="e => formCarTypeData.addtypeDeposit = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(10,formCarTypeData.addtypeDeposit)">
          </el-input>
        </el-form-item>
        <el-form-item label="日租费用标准:" prop="addtypeDailyFee">
          <el-input v-model="formCarTypeData.addtypeDailyFee" placeholder="请输入日租费用"
          @input="e => formCarTypeData.addtypeDailyFee = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(11,formCarTypeData.addtypeDailyFee)">
            <template slot="append">/天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="月租费用标准:" prop="addtypeMonthlyFee">
          <el-input v-model="formCarTypeData.addtypeMonthlyFee" placeholder="请输入月租费用"
          @input="e => formCarTypeData.addtypeMonthlyFee = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(12,formCarTypeData.addtypeMonthlyFee)">
            <template slot="append">/月</template>
          </el-input>
        </el-form-item>
        <el-form-item label="年租费用标准:" prop="addtypeAnnualFee">
          <el-input v-model="formCarTypeData.addtypeAnnualFee" placeholder="请输入年租费用"
          @input="e => formCarTypeData.addtypeAnnualFee = e.replace(/[^\d.]/g,'')"
            @keyup.native="keyUpValidate(13,formCarTypeData.addtypeAnnualFee)">
            <template slot="append">/年</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feeDialogVisable = false">返 回</el-button>
        <el-button type="primary" @click="createCarType()">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 查看费用标准抽屉 -->
    <el-drawer title="费用标准" size="15%" :visible.sync="feeDrawer" :with-header="false">
      <div class="block" style="padding-left: 30px;padding-top: 60px;">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index" color='#0bbd87' size="large">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>


  </div>

</template>

<script>
  import Pagination from '@/components/common/Pagination'
  import {
    carTypeList
  } from '@/api/car'
  import {
    carTypeSave,getAllCarTypes
  } from '@/api/car'
  import {
    carTypeDelete
  } from '@/api/car'

  export default {
    name: 'CarType',
    components: {
      Pagination
    },
    data() {
      return {
        listLoading: true,
        listData: [],
        totalCounts: 0,
        entityIdOptions: [],
        enbleSelect: true,
        tableOptions: [
          '编辑',
          // '配置费用',
          // '费用详情',
          '删除'
        ],
        listQuery: {
          pageIndex: 1,
          pageSize: 10,
          params: {
            name: undefined,
          },
          fuzzySearch: true,

        },
        // 弹出框是否可见
        carTypeDialogVisable: false,
        // 配置费用弹出框是否可见
        feeDialogVisable: false,
        dialogTitleType: 'create',
		carTypeOptions:[],
        formCarTypeData: {
		  addmodelId:'',
          addtypeId: '',
          addmodelName: '',
          addtypeLength: '',
          addtypeWidth: '',
          addtypeHeight: '',
          addtypeWeight: '',
        },
        error_input: false,
        // 打开费用标准抽屉
        feeDrawer: false,
        // 抽屉显示费用详情内容
        activities: [{
          content: '机器人成本费用标准:',
        }, {
          content: '保险费用标准:',
        }, {
          content: '维修保养费用标准:',
        }, {
          content: '充电费用标准:',
        }, {
          content: '发票税费标准:',
        }, {
          content: '押金费用标准:',
        }, {
          content: '日租费用标准:',
        }, {
          content: '月租费用标准:',
        }, {
          content: '年租费用标准:',
        }, ],
      }
    },
    methods: {
      initEntities() {
        this.entitys = JSON.parse(localStorage.entity)
        for (let k in this.entitys) {
          this.entityIdOptions.push({
            value: parseInt(k),
            label: this.entitys[k]
          })
        }
        this.listQuery.entityId = this.entityIdOptions[0].value
        this.handleFilter()
      },
      /**
       * 处理操作
       */
      handleOperator(index, row) {
        switch (index) {
          case 0:
            // index: 0 表示编辑车辆类型
            this.editCarType(row)
            break;
          case 1:
            // index: 1 表示配置费用
            this.configurationCost(row)
            break;
          case 2:
            // index: 2 表示查看费用详情
            this.openFeeDrawer(row)
            break;
          case 3:
            // index: 3 表示删除车辆类型
            this.handleDelete(row)
            break;
          default:
            break;
        }
      },

      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      /**
       * handleFilter 用于请求车辆类型数据
       */
      handleFilter() {
        this.listLoading = true;
        // 请求数据
        carTypeList(this.listQuery).then(res => {
          // 获取数据成功
          let data = res.pageData
          this.totalCounts = data.totalCounts
          // 对后端数据进行解析
          this.listData = data.datas.map(item => {
            return {
              id: item.id,
              name: item.name,
              size: item.length + "m × " + item.width + "m × " + item.height + "m",
              length: item.length,
              width: item.width,
              height: item.height,
              weight: item.weight,
			  typeName:item.typeName,
			  functions:item.functions,
			  typeId:item.typeId
            }
          })
          this.listLoading = false
        })

      },
	  
	  /**
	   * 获取车辆类型
	   */
	  getCarTypeSelect(){
	    getAllCarTypes().then(response =>{
	      this.carTypeOptions = response.data
	    })
	  },
	  
      /**
       * 删除按钮事件处理
       */
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          carTypeDelete(row.id).then(res => {
            if (res.result === '0' || res.result === '2') {
              this.$message.error(res.message);
            } else if (res.result === '1') {
              this.$alert(res.message);
              this.handleFilter();
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      /**
       * 编辑按钮事件处理
       */
      editCarType(row) {
	    this.getCarTypeSelect()
		this.formCarTypeData.addmodelId = row.id;
        this.formCarTypeData.addtypeId = row.typeId;
        this.formCarTypeData.addmodelName = row.name;     
        this.formCarTypeData.addtypeLength = row.length;
        this.formCarTypeData.addtypeWidth = row.width;
        this.formCarTypeData.addtypeHeight = row.height;
        this.formCarTypeData.addtypeWeight = row.weight;
        this.dialogTitleType = 'edit';
        this.carTypeDialogVisable = true;
        this.enbleSelect = true
      },
      /**
       * 配置费用按钮事件处理
       */
      configurationCost(row) {
        this.formCarTypeData.addtypeId = row.id;
        this.formCarTypeData.addtypeEntityId = row.entityId;
        this.formCarTypeData.addtypeName = row.name;
        this.formCarTypeData.addtypeModel = row.model
        this.formCarTypeData.addtypeLength = row.length;
        this.formCarTypeData.addtypeWidth = row.width;
        this.formCarTypeData.addtypeHeight = row.height;
        this.formCarTypeData.addtypeWeight = row.weight;
        this.formCarTypeData.addtypeCarCost = row.carCost;
        this.formCarTypeData.addtypeInsurance = row.insurance;
        this.formCarTypeData.addtypeMaintenanceFees = row.maintenanceFees;
        this.formCarTypeData.addtypeChargingFee = row.chargingFee;
        this.formCarTypeData.addtypeInvoiceTax = row.invoiceTax;
        this.formCarTypeData.addtypeDeposit = row.deposit;
        this.formCarTypeData.addtypeDailyFee = row.dailyFee;
        this.formCarTypeData.addtypeMonthlyFee = row.monthlyFee;
        this.formCarTypeData.addtypeAnnualFee = row.annualFee;
        this.dialogTitleType = 'edit';
        this.feeDialogVisable = true;
        this.enbleSelect = true
      },
      /**
       * 新增按钮
       */
      handleCreate() {
		this.getCarTypeSelect()
        this.clearForm();
        this.dialogTitleType = 'create';
        this.carTypeDialogVisable = true;
        this.enbleSelect = false
      },
      handlePageChange(data) {
        this.listQuery.pageIndex = data.page
        this.listQuery.pageSize = data.limit
        this.handleFilter()
      },
      /**
       * 清除输入框
       */
      clearForm() {
        this.formCarTypeData.addtypeId = '';
        this.formCarTypeData.addmodelName = '';
        this.formCarTypeData.addmodelId = '';
        this.formCarTypeData.addtypeLength = '';
        this.formCarTypeData.addtypeWidth = '';
        this.formCarTypeData.addtypeHeight = '';
        this.formCarTypeData.addtypeWeight = '';
      },
      /**
       * 校验
       */
      keyUpValidate(index, value) {
         console.log(value.split('.')[1]);
        let returnVal = value;
        // 第一个字符不能是 '.'
        let validate1 = /^\./g;
        // 只能包含数字或 '.'
        let validate2 = /[^\d.]/g;
        if (validate1.test(value)) {
          this.$message.error('第一个字符不能是   .  ');
          returnVal = "";
        } else if (validate2.test(value)) {
          this.$message.error('只能包含数字或  . ');
          returnVal = value.slice(0, value.length - 1);
        } else if (value.split('.').length - 1 > 1) {
          this.$message.error('只能含有一个 小数点');
          returnVal = value.replace(/\.{2,}/g, '') // 只保留第一个. 清除多余的
          returnVal = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        } /* else if (value.split('.')) {

          } */

         if(value.split('.')[1] != null && value.split('.')[1] != '' && value.split('.')[1].length > 2){
           this.$message.error('小数点后只能输入两位小数');
           returnVal = value.split('.')[0] + "." + value.split('.')[1].substr(0,2);
         }
        switch (index) {
          case 1:
            this.formCarTypeData.addtypeLength = returnVal
            break;
          case 2:
            this.formCarTypeData.addtypeWidth = returnVal
            break;
          case 3:
            this.formCarTypeData.addtypeHeight = returnVal
            break;
          case 4:
            this.formCarTypeData.addtypeWeight = returnVal
            break;
          case 5:
            this.formCarTypeData.addtypeCarCost = returnVal
            break;
          case 6:
            this.formCarTypeData.addtypeInsurance = returnVal
            break;
          case 7:
            this.formCarTypeData.addtypeMaintenanceFees = returnVal
            break;
          case 8:
            this.formCarTypeData.addtypeChargingFee = returnVal
            break;
          case 9:
            this.formCarTypeData.addtypeInvoiceTax = returnVal
            break;
          case 10:
            this.formCarTypeData.addtypeDeposit = returnVal
            break;
          case 11:
            this.formCarTypeData.addtypeDailyFee = returnVal
            break;
          case 12:
            this.formCarTypeData.addtypeMonthlyFee = returnVal
            break;
          case 13:
            this.formCarTypeData.addtypeAnnualFee = returnVal
            break;
          case 14:
            this.formCarTypeData.addtypeTopSpeed = returnVal
            break;
          case 15:
            this.formCarTypeData.addtypeEnduranceTime = returnVal
            break;
          case 16:
            this.formCarTypeData.addtypeBatteryVoltage = returnVal
            break;
          case 17:
            this.formCarTypeData.addtypeBatteryCapacity = returnVal
            break;
          default:
            this.$message.error('校验对象错误');
        }
      },
      /**
       * 	确定按钮事件处理
       */
      createCarType() {
        this.check_inputs();
        if (this.dialogTitleType === 'create') {
          this.formCarTypeData.addmodelId = null;
        }
        console.log(!this.error_input);
        if (!this.error_input) {
          carTypeSave(this.formCarTypeData).then(res => {
            if (res.result === '0' || res.result === '2') {
              this.$message.error(res.message);
            } else if (res.result === '1') {
              this.carTypeDialogVisable = false;
              this.feeDialogVisable = false;
              this.handleFilter();
              this.$alert(res.message);
            }
          })
        }
      },
      /**
       * 空值校验
       */
      check_inputs() {
        this.error_input = false;
        if (this.formCarTypeData.addmodelName === '') {
          this.$alert('型号名称不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeId === '') {
          this.$alert('类型不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeLength === '') {
          this.$alert('长度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeWidth === '') {
          this.$alert('宽度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeHeight === '') {
          this.$alert('高度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeWeight === '') {
          this.$alert('重量不能为空')
          this.error_input = true
          return
        }
        // if (!this.enbleSelect) {
        //   //新建
        //   if (this.formCarTypeData.addtypeEntityId == undefined) {
        //     this.$message({
        //       message: "选择一个单位",
        //       type: 'info'
        //     })
        //     this.error_input = true
        //     return
        //   }
        // }
      },
      /**
       * 费用详情按钮事件处理
       */
      openFeeDrawer(row) {
        this.activities = [{
          content: '机器人成本费用标准:' + row.carCost + '元',
        }, {
          content: '保险费用标准:' + row.insurance + '元',
        }, {
          content: '维修保养费用标准:' + row.maintenanceFees + '元',
        }, {
          content: '充电费用标准:' + row.chargingFee + '元',
        }, {
          content: '发票税费标准:' + row.invoiceTax + '元',
        }, {
          content: '押金费用标准:' + row.deposit + '元',
        }, {
          content: '日租费用标准:' + row.dailyFee + '元/天',
        }, {
          content: '月租费用标准:' + row.monthlyFee + '元/月',
        }, {
          content: '年租费用标准:' + row.annualFee + '元/年',
        }]
        this.feeDrawer = true;
      },

    },
    mounted() {
      this.initEntities()
    },
  }
</script>

<style>

</style>
